import React from 'react';
import { ValidationIcon } from '../../../icons';

interface EmailFieldProps {
  value: string;
  error?: string;
  isValid: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const EmailField: React.FC<EmailFieldProps> = ({
  value,
  error,
  isValid,
  onChange,
  onBlur,
}) => {
  const inputBaseClass = 'w-full p-3 border rounded-md shadow-sm text-sm focus:ring-primary focus:border-primary bg-input-bg-light dark:bg-input-bg-dark text-text-primary dark:text-gray-200 placeholder-gray-400 dark:placeholder-gray-500';
  const errorBorderClass = 'border-red-500';
  const normalBorderClass = 'border-medium-gray dark:border-gray-600';

  return (
    <div className="relative">
      <label htmlFor="email" className="block text-sm font-medium text-text-secondary dark:text-gray-400 mb-1">
        Email *
      </label>
      <div className="relative">
      <input
        type="email"
        name="email"
        id="email"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        minLength={4}
        maxLength={100}
        autoComplete="email"
        className={`${inputBaseClass} ${error ? errorBorderClass : normalBorderClass}`}
        aria-describedby={error ? 'email-error' : undefined}
      />
      <ValidationIcon isValid={isValid} />
      {error && (
        <p id="email-error" className="text-xs text-red-500 mt-1">
          {error}
        </p>
      )}
      </div>
    </div>
  );
};

export default EmailField; 